export default "__VITE_ASSET__DWMmNajz__"